import React from 'react';
import Image from 'next/image';

import { IImage } from 'utils/types';
import { BackgroundSection } from 'components/background/BackgroundSection';

import s from './SplitPageLayout.module.scss';

type Props = {
  color?: string;
  image?: IImage;
  children: React.ReactNode;
};

export const SplitPageSection = ({ color, image, children }: Props) => {
  return (
    <BackgroundSection color={color ? color.toLowerCase() : undefined}>
      <div className={s.section}>
        {image?.portrait && (
          <div className={s.section__image}>
            <Image
              src={image.portrait?.url ?? image.url}
              layout="fill"
              objectFit="cover"
              objectPosition="center"
              className={s.item__img}
            />
          </div>
        )}
        <div className={s.section__container}>
          <div className={s.section__content}>{children}</div>
        </div>
      </div>
    </BackgroundSection>
  );
};
